<template>
  <div class="row">
    <!-- main title -->
    <div class="col-12">
      <div class="main__title">
        <h2>افزودن آیتم جدید</h2>
      </div>
    </div>
    <div class="col-12 col-md-12 ">
      <div class="form__group">
        <ImageSelector label=" تصویر کاور (450*1920)"
                       v-model:previewImage="file_preview_cover"
                       @imagefile="(n) => file_cover = n"
        />

      </div>
    </div>
    <div class="col-12">
      <form action="#" class="form">
        <div class="row">
          <div class="col-12 col-md-5 form__cover">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-12">
                <div class="form__group">
                  <ImageSelector class="image-size" label="تصویر (888*625)"
                                 v-model:previewImage="file_preview"
                                 @imagefile="(n) => file = n"
                  />

                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-7 form__content">
            <div class="row">
              <div class="col-6">
                <div class="form__group">
                  <input v-model="name" type="text" class="form__input" placeholder="عنوان">
                </div>
              </div>
              <div class="col-6" >
                <div class="form__group">
                  <label>سئو عنوان</label>
                  <input v-model="seo_title" type="text" class="form__input" >
                  <SeoProgress :string="seo_title"
                               :min_perfect="50"
                               :max_perfect="60" />
                </div>
              </div>
              <div class="col-12">
                <div class="form__group">
                                    <textarea v-model="summary" id="text" name="text" class="form__textarea"
                                              placeholder="توضیحات"></textarea>

                </div>
              </div>

              <div class="col-12">
                <div class="form__group">
                                    <textarea v-model="seo_description" id="text" name="text" class="form__textarea"
                                              placeholder="سئو توضیحات"></textarea>
                  <SeoProgress :string="seo_description"
                               :min_perfect="120"
                               :max_perfect="150" />
                </div>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <div class="form__group">
                  <label style="color: white">سال تولید</label>
                  <input v-model="release_year" type="text" class="form__input"
                         placeholder="سال تولید">
                </div>
              </div>

              <!--                            <div class="col-12 col-sm-6 col-lg-3">-->
              <!--                                <div class="form__group">-->
              <!--                                    <input v-model="duration" type="text" class="form__input"-->
              <!--                                           placeholder="مدت زمان فیلم">-->
              <!--                                </div>-->
              <!--                            </div>-->
              <div class="col-12 col-sm-6 col-lg-3">
                <div class="form__group">
                  <label style="color: white">رتبه IMDB</label>
                  <input v-model="imdb" type="text" class="form__input" placeholder="رتبه IMDB">
                </div>
              </div>
              <div class="col-12 col-lg-4">
                <div class="form__group">
                  <label style="color: white">رده بندی سنی</label>
                  <select v-model="selected_age" class="form__input">
                    <option v-for="age in age_rates" :value="age.id"
                            :selected="selected_age == age.id ?'selected' : ''">{{ age.title }}
                    </option>
                  </select>

                </div>
              </div>

              <div class="col-12 col-lg-3" v-if="!first_data">
                <div class="form__group">
                  <label style="color: white">کشور ها</label>

                  <treeselect v-model:modelValue="selected_country"
                              :multiple="true"
                              :normalizer="normalizer_genres"
                              :options="countries"
                  />
                </div>
              </div>

              <div class="col-12 col-lg-3" v-if="!first_data">
                <div class="form__group">
                  <label style="color: white">ژانر ها</label>
                  <treeselect
                      :multiple="true"
                      v-model:modelValue="selected_genre"
                      :normalizer="normalizer_genres"

                      :options="genres"/>

                </div>
              </div>
              <div class="col-12 col-lg-3" v-if="!first_data">
                <div class="form__group">
                  <label style="color: white">دسته بندی ها</label>
                  <treeselect

                      v-model:modelValue="selected_category"
                      :multiple="true"
                      :normalizer="normalizer_cats"
                      :disableBranchNodes="true"
                      :options="categories"/>

                </div>
              </div>
              <div class="form__group col-3">
                <label style="color: white">صاحب امتیاز</label>
                <treeselect

                    v-model:modelValue="selected_owner"
                    :normalizer="normalizer_persons"
                    :loadOptions="load_persons"
                    :async="true"/>

              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6 form__group">
                <label>لینک ویدئو</label>
                <input v-if="type==1 && status_form==0" v-model="link" type="text" class="form__input"
                       placeholder="لینک ویدئو">
              </div>
              <div class="col-6" v-if="!first_data">

                <div class="form__group ">
                  <label>لینک تیزر</label>

                  <input

                      v-model="teaser_link"
                      type="text" class="form__input"
                      placeholder="لینک تیزر"/>

                </div>
              </div>
            </div>

            <ul class="form__radio">
              <li>
                <span>نوع:</span>
              </li>
              <li>
                <input :value="1"
                       @input="event => type = event.target.value" id="type1"
                       :checked="type == 1"
                       type="radio" name="type"
                >
                <label for="type1">فیلم</label>
              </li>
              <li>
                <input :value="2"
                       @input="event => type = event.target.value"
                       :checked="type == 2"
                       id="type2" type="radio" name="type">
                <label for="type2">سریال</label>
              </li>
              <li>
                <input :value="3"
                       @input="event => type = event.target.value"
                       :checked="type == 3"
                       id="type3" type="radio" name="type">
                <label for="type3">آموزشی</label>
              </li>
            </ul>
          </div>
          <div v-if="type==2 || type==3">
            <label style="color:white">نمایش تبلیغ در همه ایپزود ها</label>
            <select v-model="ads_all_episode">
              <option value="0" :selected="ads_all_episode==0">عدم نمایش</option>
              <option value="1" :selected="ads_all_episode==1">نمایش</option>
            </select>
          </div>

          <div class="col-12">
            <ul class="form__radio">
              <li>
                <span>وضعیت:</span>
              </li>
              <li>
                <input :value="0"
                       @input="event => status = event.target.value"
                       id="status2" type="radio" name="status" :checked="status == 0">
                <label for="status2">غیر فعال</label>
              </li>
              <li>
                <input :value="1"
                       @input="event => status = event.target.value" id="status1"
                       :checked="status == 1"
                       type="radio" name="status">
                <label for="status1">فعال</label>
              </li>

              <li>
                <input :value="2"
                       :checked="status == 2"
                       @input="event => status = event.target.value"
                       id="status3" type="radio" name="status">
                <label for="status3">بزودی</label>
              </li>
            </ul>
          </div>
          <div class="col-12">
            <ul class="form__radio">
              <li>
                <span>نوع پرداخت:</span>
              </li>
              <li>
                <input :value="1"
                       @input="event => pay_type = event.target.value"
                       id="pay_type2" type="radio" name="pay_type"
                       :checked="pay_type == 1"

                >
                <label for="pay_type2">رایگان</label>
              </li>
              <li>
                <input :value="2"
                       @input="event => pay_type = event.target.value" id="pay_type1"
                       :checked="pay_type == 2"

                       type="radio" name="pay_type">
                <label for="pay_type1">اشتراکی</label>
              </li>

              <li>
                <input :value="3"
                       @input="event => pay_type = event.target.value"
                       :checked="pay_type == 3"

                       id="pay_type3" type="radio" name="pay_type">
                <label for="pay_type3">پکیج</label>
              </li>
            </ul>
          </div>
          <div class="col-12 col-sm-6 col-lg-3" v-if="pay_type==3">
            <div class="form__group">
              <label>قیمت فعلی</label>
              <input v-model="price" type="text" class="form__input" placeholder="قیمت">
            </div>
          </div>
          <div class="col-12 col-sm-6 col-lg-3" v-if="pay_type==3">
            <div class="form__group">
              <label>قیمت قبلی بدون تخفیف</label>
              <input v-model="old_price" type="text" class="form__input"
                     placeholder="قیمت قبلی (بدون تخفیف)">
            </div>
          </div>
          <div class="col-12 col-sm-6 col-lg-3" v-if="pay_type==3">
            <div class="form__group">
              <label>توضیحات خرید</label>
              <textarea v-model="buy_summary" type="text" class="form__input"
                                      placeholder="توضیحات خرید"></textarea>
            </div>
          </div>


          <div>
            <div style="display: flex">
              <button
                  @click="$router.push({path:'/item-persons/'+status_form})"
                  type="button" class="form__btn"
                  v-if="status_form!=0">بازیگران
              </button>

              <button
                  @click="$router.push({path:'/seasons/'+status_form})"
                  type="button" class="form__btn"
                  v-if="status_form!=0 && (type==2  || type==3)">فصل ها
              </button>
              <button
                  @click="$router.push({path:'/item-certificate/'+status_form})"
                  type="button" class="form__btn"
                  v-if="status_form!=0 && (type==3)">گواهینامه
              </button>
              <button
                  v-if="status_form!=0 && type==1"
                  @click="$router.push({path:'/movie_sources/'+status_form})"
                  type="button" class="form__btn">منابع
              </button>
              <button
                  v-if="status_form!=0 && type==1"
                  @click="$router.push({path:'/movie_subtitle/'+status_form})"
                  type="button" class="form__btn">زیرنویس ها
              </button>
            </div>
          </div>

          <div class="col-12">
            <div class="row">

              <div class="save-btn">
                <button v-if="status_form==0" @click="insert_data()" type="button" class="form__btn">
                  ثبت
                </button>
                <button v-if="status_form!=0" @click="insert_data()" type="button" class="form__btn">
                  ذخیره
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- end form -->
  </div>
</template>

<script>
import axios from "axios";
// import {bus} from '../main';
import ImageSelector from "@/views/CustomComponent/ImageSelector";
// import the styles
import Treeselect, {ASYNC_SEARCH} from 'vue3-treeselect'
import 'vue3-treeselect/dist/vue3-treeselect.css'
import SeoProgress from "@/views/CustomComponent/SeoProgress.vue";
const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}
export default {
  name: 'HelloWorld',
  data() {
    return {
      seo_title:'',
      seo_description:'',
      theme_mode_parent: '',
      mybutton: '',
      home_data: {slides: []},
      file_preview: '',
      file: null,
      ads_all_episode: 0,
      first_data: true,
      file_preview_cover: '',
      file_cover: null,
      selected_country: [],
      countries: [],
      selected_genre: [],
      genres: [],
      selected_category: [],
      categories: [],
      name: '',
      summary: '',
      release_year: '',
      duration: '',
      imdb: '',
      price: '',
      link: '',
      old_price: '0',
      buy_summary: '',
      type: 1,
      status: 0,
      pay_type: 1,
      age_rates: [],
      selected_age: 0,
      status_form: 0,
      normalizer_genres(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
      normalizer_cats(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
      teaser_link: '',
      selected_owner: null,
      load_persons({action, searchQuery, callback}) {
        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            // formData.append('token', localStorage.getItem("login_info"));
            formData.append('txt', searchQuery);
            var config = {
              headers: {
                'Authorization': "Bearer " + localStorage.getItem("login_info")
              }, show_pros: true
            }
            axios.post('search_user', formData, config).then(function (response) {
              console.log(response.data)
              options = response.data;
              callback(null, options);
            })
                .catch(function (error) {
                  console.log(error);
                });

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.id,
          label: node.name + " " + node.phone,
        }
      },
    }
  },
  components: {
    ImageSelector,
    Treeselect,
    SeoProgress
  },
  mounted() {
    this.get_genres();
    this.get_countries();
    this.get_categories();
    this.get_ages();
    if (this.$route.params.id != null) {
      this.status_form = this.$route.params.id
      this.get_data();
    } else {
      this.first_data = false
    }
  },
  methods: {
    get_ages() {

      var self = this;

      var formData = new FormData();

      this.axios.post('get_age_grade', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.age_rates = content_data
        self.selected_age = self.age_rates[0].id
      }).catch(function (error) {
        console.log(error);
      });


    },

    get_data() {

      var self = this;

      var formData = new FormData();
      formData.append('id', this.status_form)
      this.axios.post('get_poster_info', formData, {}).then(function (response) {

        var content_data = response.data;
        self.file_preview = content_data.image
        self.file_preview_cover = content_data.cover_image
        content_data.countries.forEach(function (val) {
          self.selected_country.push(parseInt(val.country_id))
        })
        content_data.genres.forEach(function (val) {
          self.selected_genre.push(parseInt(val.genre_id))
        })

        content_data.categories.forEach(function (val) {
          self.selected_category.push(parseInt(val.cat_id))


        })
        self.first_data = false,

            self.name = content_data.name
            self.seo_title = content_data.seo_title
            self.seo_description = content_data.seo_description
        self.summary = content_data.summary
        self.release_year = content_data.year
        self.duration = content_data.duration
        self.imdb = content_data.imdb
        if (content_data.teaser != null) {
          self.teaser_link = content_data.teaser.link
        }
        self.ads_all_episode = content_data.ads_all_episode
        self.price = content_data.price
        self.old_price = content_data.old_price
        self.buy_summary = content_data.buy_summary
        self.type = content_data.type
        self.status = parseInt(content_data.view_status)
        self.pay_type = content_data.pay_type
        self.selected_age = parseInt(content_data.age_grade)
        // items = content_cats.orders;

      }).catch(function (error) {
        console.log(error);
      });


    },
    get_genres() {

      var self = this;

      var formData = new FormData();

      this.axios.post('get_genres', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;

        self.genres = content_data

      }).catch(function (error) {
        console.log(error);
      });


    },
    get_countries() {

      var self = this;

      var formData = new FormData();

      this.axios.post('get_countries', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.countries = content_data

      }).catch(function (error) {
        console.log(error);
      });


    },
    get_categories() {

      var self = this;

      var formData = new FormData();

      this.axios.post('get_all_categories', formData, {}).then(function (response) {

        var content_data = response.data.data;

        // items = content_cats.orders;
        content_data.forEach(function (val) {
          val.children.forEach(function (val2) {
            val2.value = val2.id;
            val2.label = val2.name
          })
        })
        self.categories = content_data

      }).catch(function (error) {
        console.log(error);
      });


    },
    insert_data() {

      var self = this;

      var formData = new FormData();
      var url = ""
      if (this.status_form == 0) {
        url = "insert_poster";
      } else {
        url = "edit_poster"
        formData.append("id", this.status_form)

      }
      formData.append("selected_age", this.selected_age)


      formData.append("seo_title", this.seo_title)
      formData.append("seo_description", this.seo_description)
      formData.append("name", this.name)
      formData.append("type", this.type)
      formData.append("summary", this.summary)
      formData.append("pay_type", this.pay_type)
      formData.append("link", this.link)
      formData.append("view_status", this.status)
      formData.append("price", this.price)
      formData.append("old_price", this.old_price)
      formData.append("buy_summary", this.buy_summary)
      formData.append("year", this.release_year)
      formData.append("ads_all_episode", this.ads_all_episode)
      formData.append("imdb", this.imdb)
      formData.append("duration", this.duration)
      formData.append("cover_image", this.file_cover)
      formData.append("poster_image", this.file)
      formData.append("countries", JSON.stringify(this.selected_country))
      formData.append("genres", JSON.stringify(this.selected_genre))
      formData.append("categories", JSON.stringify(this.selected_category))
      formData.append("selected_owner", this.selected_owner)
      formData.append("teaser_link", this.teaser_link)


      this.axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data.data;
        self.$router.push({path: '/items-list'})
        // items = content_cats.orders;


      }).catch(function (error) {
        console.log(error);
        self.$toast.error('خطا در ثبت اطلاعات');
      });


    },
  }
}
</script>

